export default {"src":"/_next/static/image/public/images/ic_settings_white_vertical_menu.acc02e33f9788bfbf30bc43b3cb0a7c9.svg","height":20,"width":20};